import React from "react"
import classNames from "classnames"

import OperatorV2 from "../OperatorV2"

import styles from "./index.module.less"

interface Top3OperatorsProps {
    className?: string
    style?: React.CSSProperties
    profession: string
    operators: {
        id: string
        name: string
        profession: string
        rarity: number
    }[]
}

const professionMap = {
    PIONEER: "VANGUARD",
    WARRIOR: "GUARD",
    TANK: "DEFENDER",
    SNIPER: "SNIPER",
    CASTER: "CASTER",
    MEDIC: "MEDIC",
    SUPPORT: "SUPPORTER",
    SPECIAL: "SPECIALIST",
}

const Top3OperatorsV2: React.FC<Top3OperatorsProps> = (props) => {
    const { className, style, profession, operators = [] } = props

    return (
        <div
            className={classNames(styles.top3Operators, className)}
            style={style}
        >
            <div className={styles.operators}>
                {operators.map((i) => (
                    <OperatorV2
                        key={i.id}
                        className={styles.operator}
                        data={i}
                    />
                ))}
            </div>
            <div className={styles.profession}>
                <div
                    className={styles.icon}
                    data-value={profession.toLowerCase()}
                />
                <div className={styles.name}>{professionMap[profession]}</div>
            </div>
        </div>
    )
}

export default Top3OperatorsV2
